import { requestHandler } from "../lib/utils/network-client";

export function getCourses(params = {}) {
  return requestHandler("/courses", {
    params
  });
}

export function createCourse(payload) {
  return requestHandler("/courses", {
    method: "POST",
    body: payload
  });
}

export function updateCourse(id, payload) {
  return requestHandler(`/courses/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deleteCourse(id) {
  return requestHandler(`/courses/${id}`, {
    method: "DELETE"
  });
}
